import { Alert, Button, Card, Col, Dropdown, Form, Input, Row, Select, Switch, Table, notification } from "antd"
import { useEffect, useState } from "react";
import AddressSection from "./Components/AddressSection";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs'
import { get, remove, save } from "../../System/Api/API";
import generateMiles from "./Quote/generateMiles";
import generatePrices from "./Quote/generatePrices";
import MapSection from "./Quote/MapSection";
import Running from "../../System/Components/Running";
import { useGlobal } from "../../System/Global/GlobalProvider";
import { escapeNested, parseStringifiedArrays, stringifyArraysInObject, unescapeNested } from "../../System/Global/unescapeArray";

export const BookingView = () => {

    const [ form ] = Form.useForm()
    const { UserData } = useGlobal()
    const [ client, setClient ] = useState()
    const [ collections, setCollections ] = useState([])
    const [ deliveries, setDeliveries ] = useState([])
    const { bookingKey } = useParams();
    const [ screen, setScreen ] = useState("details")
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ booking, setBooking ] = useState();
    const [ isLoading, setIsLoading ] = useState(false)
    const [ templates, setTemplates ] = useState([])
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [ typeCode, setTypeCode ] = useState() // used for avonmouth site type 3
    const [ mileage, setMileage ] = useState()
    const [ price, setPrice ] = useState()
    const navigate = useNavigate()


    const generateAddress = (b, prefix) => {

        console.log(b, prefix)

        let newAddresses = [{
            name:           b[`${prefix}_name`],
            addressLine1:   b[`${prefix}_addressLine1`],
            addressLine2:   b[`${prefix}_addressLine2`],
            addressLine3:   b[`${prefix}_addressLine3`],
            townName:       b[`${prefix}_townName`],
            postCode:       b[`${prefix}_postCode`],
            country:        b[`${prefix}_country`],
            date:           dayjs(b[`${prefix}_date`]).format('YYYY-MM-DD'),
            time:           b[`${prefix}_time`] !== "ASAP" ? dayjs().hour(parseInt(b[`${prefix}_time`].split(':')[0])).minute(parseInt(b[`${prefix}_time`].split(':')[1])) : dayjs(),
            timeType:       b[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
            instructions:   b[`${prefix}_instructions`],
            reference:      b[`${prefix}_reference`],
        }]

        let items = prefix === "col" ? b.collections : b.deliveries;

        console.log('items', items)

        if (Array.isArray(items)) {
            items.forEach(item => newAddresses.push({
                name:           item[`${prefix}_name`],
                addressLine1:   item[`${prefix}_addressLine1`],
                addressLine2:   item[`${prefix}_addressLine2`],
                addressLine3:   item[`${prefix}_addressLine3`],
                townName:       item[`${prefix}_townName`],
                postCode:       item[`${prefix}_postCode`],
                country:        item[`${prefix}_country`],
                date:           dayjs(item[`${prefix}_date`]).format('YYYY-MM-DD'),
                time:           item[`${prefix}_time`] !== "ASAP" ? dayjs().hour(parseInt(item[`${prefix}_time`].split(':')[0])).minute(parseInt(item[`${prefix}_time`].split(':')[1])) : dayjs(),
                timeType:       item[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
                instructions:   item[`${prefix}_instructions`],
                reference:      item[`${prefix}_reference`],
            }))
        } else {
            console.error('items is not an array:', items)
        }

        if (prefix === "col") {
            setCollections(newAddresses)
        } else {
            setDeliveries(newAddresses)
        }

    }

    useEffect( () => {

        ( async () => {

            let _booking = await get('bookings', {bookingKey: bookingKey})
            _booking = unescapeNested(_booking[0])
            _booking = parseStringifiedArrays(_booking)
            
            setBooking(_booking)

            generateAddress(_booking, 'col')
            generateAddress(_booking, 'del')

                
            form.setFieldsValue({
                itemCount:      _booking.itemCount,
                itemKgs:        _booking.itemKgs,
                itemText:       _booking.itemText,
                itemType:       _booking.itemType,
                typeCode:       _booking.typeCode,
                vanType:        _booking.vanType,
                basePrice:      _booking.basePrice,
                vatCode:        _booking.vatCode,
                ignorePod:      _booking.ignorePod,
                customsBooking: _booking.customsBooking,
                orderNo:        _booking.orderNo,
                customerRef:    _booking.customerRef,
            })

            setTypeCode(_booking.typeCode)

            if (_booking.roundTrip === 1) {
                setIsRoundTrip(true)
            }
            

            const _client = await get('clients', {clientKey: UserData.clientKey})
            setClient(_client[0])
            setBooking(_booking)

            setIsLoading(false)

            
        })()
        

    },[])

    
    const priceCard = () => {

        return (
            <Card>
                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>

                
                
                <Row gutter={16} display="flex" align={"middle"}>
                    <Col xs={10}>
                        <Form.Item label="Price" name="basePrice" rules={[
                            {
                                required: true,
                                message: 'Please enter a price!',
                            }]}>
                            <Input disabled type="number"/>
                        </Form.Item>
                    </Col>
                    
                    
                    <Col xs={14}>
                        { typeCode !== "3" &&
                        <Form.Item label={"Vehicle Type"} name="vanType">
                                <Input disabled />
                        </Form.Item> }
                    </Col>
                    
                </Row> 
                </div>
            </Card>
        )
    }
    const detailsCard = () => {

        return (
            
            <Card>

                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>
                
                <Row gutter={16} display="flex" align={"middle"}>
                    
                    <Col xs={12}>
                        <Form.Item label="Order No" name="orderNo" rules={[
                            {
                                required: true,
                                message: 'Please enter an order number!',
                            }]}>
                            <Input disabled/>
                        </Form.Item>
                        
                    </Col>
                    <Col xs={12}>
                        <Form.Item label="Your Ref (optional)" name="customerRef">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                </div>
                
            </Card> 
        )
    }

    

    const statusStyle = {

        padding: "5px 15px",
        backgroundColor: 'black',
        color: 'white'
    }

    return (
        isLoading && booking ?  <Row gutter={16}>
        <Col xs={24}></Col></Row> :
        <div style={{padding: 20}}>
        <Row gutter={16}>
            <Col xs={24}>
            <Form form={form} layout="vertical" initialValues={booking}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h1 style={{marginTop: 0}}>{ "View Booking" }</h1>
                </div>
                <div>
                    <Switch disabled checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                </div>
                <div>
                    <div style={{
                        ...statusStyle,
                        backgroundColor: 
                            booking?.status === 'Live' ? '#e6f4ff' :
                            booking?.status === 'Transit' ? '#0958d9' :
                            booking?.status === 'Delivered' ? '#f6ffed' :
                            'black',
                        color: 
                            booking?.status === 'Live' ? '#0958d9' :
                            booking?.status === 'Transit' ? '#0958d9' :
                            booking?.status === 'Delivered' ? '#389e0d' :
                            'black',
                    }}>
                        {booking?.status}
                    </div>
                </div>
            </div>

            { booking && 

            <div>
                <>
                
                <Row gutter={10}>
                    
                    <Col span={12}>
                        <AddressSection disabled addresses={collections} setAddresses={setCollections} client={client} type="Collection"/>
                    </Col>
                    <Col span={12}>
                        <AddressSection disabled addresses={deliveries} setAddresses={setDeliveries} client={client} type="Delivery"/>
                    </Col>
                    <Col span={24}>
                        <ItemsSection/>
                    </Col>
                </Row>
                
                <Row gutter={10}>
                    <Col xs={12}>
                        { priceCard() }
                    </Col>
                    <Col xs={12}>
                        { detailsCard() }
                    </Col>
                </Row>

                </>
            </div> 
            }
            </Form>
            </Col>
        </Row>
        </div>
    )
}


const inputStyle = {
    // height: 30,
    // fontSize: 12
}
const formItemStyle = {
    marginBottom: 5,
    // minHeight: 30,
    
}

const ItemsSection = () => {

    return (
        <Card style={{margin: 10}}>
            <div style={{padding: 20, border: '1px solid #F1F2F5'}}>
            
                <Row gutter={16}>
                    <Col span={4}>
                        <Form.Item name="itemCount" label="Qty" style={formItemStyle} className="small" rules={[
                            {
                                required: true,
                                message: 'Please enter the qty!',
                            }]}>
                            <Input disabled={true} type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemType" label="Type"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the items type!',
                            }]}>
                        <Input disabled={true} style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemKgs" label="Kgs"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the weight!',
                            }]}>
                        <Input disabled={true} type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="itemText" label="Description"  style={formItemStyle}>
                        <Input disabled={true} style={inputStyle} />
                        </Form.Item>
                    </Col>
                </Row>
            
            </div>
        </Card>
    )
}
